import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  publicLinkId: string;
  formId: number;
  fileEntitiesIds: number[];
}

export const deletePublicLinkCustomFormReportFormFileFieldsRequest = ({
                                                                        formId,
                                                                        publicLinkId,
                                                                        fileEntitiesIds,
                                                                      }: RequestParams): Promise<void> => {
  return ApiServiceInstance.makeRequest(`/custom-form-report/public-link/${ publicLinkId }/${formId}/file-fields`, {
    method: 'DELETE',
    body: fileEntitiesIds,
  });
};